export const THEME = {
  bg: '#1c1c1c',
  bgDeep: '#161616',
  card: '#202020',
  cardRaised: '#262626',
  border: 'rgba(255,255,255,0.06)',
  borderStrong: 'rgba(255,255,255,0.1)',
  textPrimary: '#ffffff',
  textSecondary: '#b3b3b3',
  textMuted: '#777777',
  textFaint: 'rgba(255,255,255,0.35)',
  mint: '#12c099',
  mintDim: 'rgba(18,192,153,0.15)',
  mintFaint: 'rgba(18,192,153,0.08)',
  pink: '#C63D57',
  amber: '#fbbf24',
  amberDim: 'rgba(251,191,36,0.15)',
  blue: '#60a5fa',
  blueDim: 'rgba(96,165,250,0.15)',
};

const ALL_STAGES_COMPLETE = {
  discovery: 'complete',
  pricing: 'complete',
  capabilities: 'complete',
  buildCommitments: 'complete',
  visualAssets: 'complete',
  deck: 'complete',
  loi: 'complete',
};

export const PAIRS = [
  {
    id: 'instacart-2026-04',
    customer: 'Instacart',
    team: 'Social Impact',
    teamLead: 'Laura',
    date: 'Apr 18, 2026',
    customerColor: '#0AAD0A',
    lifecycle: 'shipped',
    shape: { teams: 1, offices: 6, employees: 'remote-first', industry: 'Tech' },
    transcript: {
      filename: 'Instacart_SocialImpact_Discovery.txt',
      words: 8420,
      confidence: 'high',
      excerpt: 'We source nonprofit partners for markets where we have no office presence, mostly through manual outreach.',
    },
    customerLogo: {
      filename: 'instacart_carrot.png',
      width: 512,
      height: 512,
      mimeType: 'image/png',
      byteSize: 14336,
    },
    chatThread: {
      messageCount: 18,
      durationMinutes: 22,
      messages: [
        { id: 'ic-m1', role: 'genesis', type: 'message', text: 'Transcript loaded for Instacart Social Impact. Stage 1 complete; 3 workflows captured.', targetField: null, createdAt: '2026-04-18T14:00:00Z', attachments: [] },
        { id: 'ic-m2', role: 'genesis', type: 'question', text: 'Confirm activation cadence is quarterly for non-office markets?', targetField: 'outputs.discovery.workflows[0].frequency', createdAt: '2026-04-18T14:03:00Z', attachments: [] },
        { id: 'ic-m3', role: 'rep', type: 'answer', text: 'Yes, 4 per year.', targetField: 'outputs.discovery.workflows[0].frequency', createdAt: '2026-04-18T14:05:00Z', attachments: [] },
        { id: 'ic-m4', role: 'genesis', type: 'message', text: 'Locked. Confidence high. Pricing draft ready for review.', targetField: null, createdAt: '2026-04-18T14:12:00Z', attachments: [] },
        { id: 'ic-m5', role: 'rep', type: 'message', text: 'Pricing looks right. Adding intake-form templates as a build commitment.', targetField: null, createdAt: '2026-04-18T14:18:00Z', attachments: [] },
        { id: 'ic-m6', role: 'genesis', type: 'message', text: 'Got it. Layer 4 saved. Deck draft ready.', targetField: null, createdAt: '2026-04-18T14:22:00Z', attachments: [] },
      ],
    },
    outcome: {
      result: 'won',
      engagementSignal: null,
      notes: 'Laura validated workflow language. Asked us to add intake form templates.',
    },
    stages: ALL_STAGES_COMPLETE,
    outputs: {
      discovery: {
        teamsInScope: 1,
        workflows: [
          { name: 'Nonprofit sourcing for non-office markets', frequency: '4/yr', volume: '12 partners', confidence: 'high' },
          { name: 'Manual outreach back-and-forth', frequency: '4/yr', volume: '8 emails/partner', confidence: 'medium' },
          { name: 'Recurring partnership renewals', frequency: 'annual', volume: '6 markets', confidence: 'high' },
        ],
        vendors: ['Deed', 'Salesforce', 'Feeding America'],
        confidence: 'high',
        notes: '',
      },
      pricing: {
        coordinationCost: 37000,
        phase3Anchor: 30000,
        enterpriseFloor: 60000,
        valueAnchor: 66000,
        maxOfThree: 66000,
        phase1: 2500,
        phase2: 4500,
        phase3: 5500,
        year1: 54000,
        alternative: '95-125K CSR coordinator',
        orchestrationFee: '15%',
      },
      capabilities: [
        { name: 'Eagle Eye', status: 'live', usedFor: 'Nonprofit discovery' },
        { name: 'Shared Inbox', status: 'live', usedFor: 'Manual outreach' },
        { name: 'Campaign Mode', status: 'live', usedFor: 'Multi-market activation' },
        { name: 'Salesforce Sync', status: 'live', usedFor: 'CRM integration' },
      ],
      buildCommitments: ['Deed API integration (Q2)', 'Quarterly cadence templates'],
      visualAssets: {
        heroPrompt: 'Instacart Social Impact discovery hero with leaf and basket motif',
        palette: ['#0AAD0A', '#0F7A0F', '#FFFFFF'],
        generatedAssetUrls: [],
      },
      deck: { slides: 13, status: 'generated', filename: 'Instacart_Discovery_Proposal.pdf' },
      loi: {
        status: 'signed',
        filename: 'Instacart_LOI.pdf',
        url: null,
        signedAt: 'Apr 22, 2026',
      },
      agentLane: null,
    },
  },
  {
    id: 'ims-2026-03',
    customer: 'IMS',
    team: 'Marketing + Travel + HR',
    teamLead: 'Alice, Jen, Carla',
    date: 'Mar 22, 2026',
    customerColor: '#1F4E79',
    lifecycle: 'shipped',
    shape: { teams: 3, offices: 8, employees: 500, industry: 'Manufacturing' },
    transcript: {
      filename: 'IMS_Marketing_Travel_HR_Discovery.txt',
      words: 11240,
      confidence: 'high',
      excerpt: 'Across marketing, travel, and HR we run print vendor sourcing, hotel booking with credit auth, and anniversary gifting.',
    },
    customerLogo: {
      filename: 'ims_logo.svg',
      width: null,
      height: null,
      mimeType: 'image/svg+xml',
      byteSize: 4096,
    },
    chatThread: {
      messageCount: 26,
      durationMinutes: 31,
      messages: [
        { id: 'ims-m1', role: 'genesis', type: 'message', text: 'Transcript loaded. 3 teams in scope. Print, travel, and gifting workflows captured.', targetField: null, createdAt: '2026-03-22T10:00:00Z', attachments: [
          { id: 'ims-att-1', filename: 'IMS_brand_guidelines.pdf', fileType: 'pdf', sizeBytes: 1843200, s3Key: 's3://genesis-uploads/dummy-ims-brand-001', uploadedAt: '2026-03-22T10:00:00Z', status: 'uploaded' },
        ] },
        { id: 'ims-m2', role: 'genesis', type: 'question', text: 'Confirm 3 teams in scope for this engagement?', targetField: 'outputs.discovery.teamsInScope', createdAt: '2026-03-22T10:04:00Z', attachments: [] },
        { id: 'ims-m3', role: 'rep', type: 'answer', text: 'Yes, 3 teams.', targetField: 'outputs.discovery.teamsInScope', createdAt: '2026-03-22T10:06:00Z', attachments: [] },
        { id: 'ims-m4', role: 'genesis', type: 'message', text: 'Acknowledged. Pricing reflects the 3-team scope.', targetField: null, createdAt: '2026-03-22T10:09:00Z', attachments: [] },
        { id: 'ims-m5', role: 'genesis', type: 'question', text: 'Should monday.com Sync be claimed live, or moved to build commitments?', targetField: 'outputs.capabilities[3].status', createdAt: '2026-03-22T10:18:00Z', attachments: [] },
        { id: 'ims-m6', role: 'rep', type: 'answer', text: 'Planned. Move to build commitments.', targetField: 'outputs.capabilities[3].status', createdAt: '2026-03-22T10:23:00Z', attachments: [] },
        { id: 'ims-m7', role: 'genesis', type: 'message', text: 'Got it. Layer 3 marked planned, Layer 4 updated.', targetField: null, createdAt: '2026-03-22T10:31:00Z', attachments: [] },
      ],
    },
    outcome: {
      result: 'won',
      engagementSignal: null,
      notes: 'Three teams in scope. Owner approved on the call. Accounting handoff to Daisy locked.',
    },
    stages: ALL_STAGES_COMPLETE,
    outputs: {
      discovery: {
        teamsInScope: 3,
        workflows: [
          { name: 'Vendor sourcing for print collateral', frequency: 'weekly', volume: '3 vendors/job', confidence: 'high' },
          { name: 'Hotel booking with credit auth forms', frequency: 'weekly', volume: '5 bookings/wk', confidence: 'high' },
          { name: 'Anniversary gifting cycles', frequency: 'monthly', volume: '~8 employees', confidence: 'medium' },
        ],
        vendors: ['J&K Services', 'uPrinting', 'Arizona Grand', 'Hampton Inn', 'gourmetgiftbaskets.com', 'monday.com', 'Wells Fargo'],
        confidence: 'high',
        notes: '',
      },
      pricing: {
        coordinationCost: 93000,
        phase3Anchor: 74400,
        enterpriseFloor: 60000,
        valueAnchor: 110000,
        maxOfThree: 110000,
        phase1: 2500,
        phase2: 5000,
        phase3: 6500,
        year1: 61500,
        alternative: '110-140K LA-market coordinators',
        orchestrationFee: '15%',
      },
      capabilities: [
        { name: 'Eagle Eye', status: 'live', usedFor: 'Print vendor sourcing' },
        { name: 'Travel Agent', status: 'live', usedFor: 'Hotel + credit auth' },
        { name: 'Recognition Agent', status: 'live', usedFor: 'Anniversary cycles' },
        { name: 'monday.com Sync', status: 'planned', usedFor: 'Workflow integration' },
      ],
      buildCommitments: ['monday.com bidirectional sync', 'Branch playbooks per office', 'Family Days 2026 coordination'],
      visualAssets: {
        heroPrompt: 'IMS Marketing + Travel + HR hero with manufacturing skyline',
        palette: ['#1F4E79', '#2F6FA8', '#FFFFFF'],
        generatedAssetUrls: [],
      },
      deck: { slides: 14, status: 'generated', filename: 'IMS_Deck.pdf' },
      loi: {
        status: 'signed',
        filename: 'IMS_LOI.pdf',
        url: null,
        signedAt: 'Mar 28, 2026',
      },
      agentLane: null,
    },
  },
  {
    id: 'wbd-csr-2026-02',
    customer: 'WBD CSR',
    team: 'CSR',
    teamLead: 'Sidney',
    date: 'Feb 11, 2026',
    customerColor: '#1E3A8A',
    lifecycle: 'shipped',
    shape: { teams: 1, offices: 100, employees: 8000, industry: 'Media' },
    transcript: {
      filename: 'WBD_CSR_Discovery.txt',
      words: 14680,
      confidence: 'high',
      excerpt: 'Nonprofit discovery spans 100+ markets with Microsoft Form intake copied into Airtable and ambassador tracking per office.',
    },
    customerLogo: {
      filename: 'wbd_logo.png',
      width: 600,
      height: 300,
      mimeType: 'image/png',
      byteSize: 24576,
    },
    chatThread: {
      messageCount: 38,
      durationMinutes: 45,
      messages: [
        { id: 'csr-m1', role: 'genesis', type: 'message', text: 'Transcript loaded. 100+ markets, 300+ partners.', targetField: null, createdAt: '2026-02-11T09:00:00Z', attachments: [] },
        { id: 'csr-m2', role: 'genesis', type: 'question', text: 'Is the CFO joining round 2 of the review?', targetField: 'outcome.engagementSignal', createdAt: '2026-02-11T09:06:00Z', attachments: [] },
        { id: 'csr-m3', role: 'rep', type: 'answer', text: 'Yes, CFO confirmed for round 2.', targetField: 'outcome.engagementSignal', createdAt: '2026-02-11T09:10:00Z', attachments: [] },
        { id: 'csr-m4', role: 'genesis', type: 'message', text: 'Adjusting price toward 65% of coordination cost given multi-team upside.', targetField: null, createdAt: '2026-02-11T09:28:00Z', attachments: [] },
        { id: 'csr-m5', role: 'rep', type: 'message', text: 'Send it.', targetField: null, createdAt: '2026-02-11T09:40:00Z', attachments: [] },
        { id: 'csr-m6', role: 'genesis', type: 'message', text: 'Marked shipped.', targetField: null, createdAt: '2026-02-11T09:45:00Z', attachments: [] },
      ],
    },
    outcome: {
      result: 'won',
      engagementSignal: null,
      notes: 'Sidney brought CFO into round 2. Pricing landed at 65% of coordination cost (lower end of band) due to multi-team expansion potential.',
    },
    stages: ALL_STAGES_COMPLETE,
    outputs: {
      discovery: {
        teamsInScope: 1,
        workflows: [
          { name: 'Nonprofit discovery across 100+ markets', frequency: 'annual', volume: '300+ partners', confidence: 'high' },
          { name: 'Microsoft Form intake + Airtable copy', frequency: 'per partner', volume: '300+ submissions', confidence: 'high' },
          { name: 'Ambassador tracking across offices', frequency: 'weekly', volume: '100+ ambassadors', confidence: 'high' },
          { name: 'Benevity + Airtable export reformat', frequency: 'per event', volume: '300+ projects', confidence: 'medium' },
        ],
        vendors: ['Airtable', 'Microsoft Forms', 'Benevity'],
        confidence: 'high',
        notes: '',
      },
      pricing: {
        coordinationCost: 138000,
        phase3Anchor: 110400,
        enterpriseFloor: 60000,
        valueAnchor: 90000,
        maxOfThree: 90000,
        phase1: 3750,
        phase2: 6000,
        phase3: 7500,
        year1: 90750,
        alternative: '8-10 person CSR core team',
        orchestrationFee: '15%',
      },
      capabilities: [
        { name: 'Eagle Eye', status: 'live', usedFor: 'Nonprofit discovery' },
        { name: 'Campaign Mode', status: 'live', usedFor: '100+ market parallelism' },
        { name: 'Ambassador Dashboard', status: 'live', usedFor: 'Per-office checklists' },
        { name: 'Benevity Export', status: 'planned', usedFor: 'Auto-format CSV' },
      ],
      buildCommitments: ['Benevity API integration', 'Airtable bidirectional sync', 'Impact Day 2026 campaign mode launch'],
      visualAssets: {
        heroPrompt: 'WBD CSR Impact Day hero with multi-market grid',
        palette: ['#1E3A8A', '#3B82F6', '#FFFFFF'],
        generatedAssetUrls: [],
      },
      deck: { slides: 16, status: 'generated', filename: 'United_WBD_CSR_Proposal.pdf' },
      loi: {
        status: 'signed',
        filename: 'United_WBD_CSR_LOI.pdf',
        url: null,
        signedAt: 'Feb 18, 2026',
      },
      agentLane: null,
    },
  },
  {
    id: 'wbd-wellbeing-2026-02',
    customer: 'WBD Wellbeing',
    team: 'Wellbeing',
    teamLead: 'Victoria',
    date: 'Feb 27, 2026',
    customerColor: '#1E3A8A',
    lifecycle: 'shipped',
    shape: { teams: 1, offices: 100, employees: 8000, industry: 'Media' },
    transcript: {
      filename: 'WBD_Wellbeing_Discovery.txt',
      words: 6100,
      confidence: 'medium',
      excerpt: 'Recurring activations like Sweet Treat Tuesday run across ~20 offices with last-mile delivery coordinated per activation.',
    },
    customerLogo: {
      filename: 'wbd_logo.png',
      width: 600,
      height: 300,
      mimeType: 'image/png',
      byteSize: 24576,
    },
    chatThread: {
      messageCount: 14,
      durationMinutes: 18,
      messages: [
        { id: 'wb-m1', role: 'genesis', type: 'message', text: 'Transcript loaded. Note: call was 50% demo, several fields inferred.', targetField: null, createdAt: '2026-02-27T11:00:00Z', attachments: [
          { id: 'wb-att-1', filename: 'office_list.xlsx', fileType: 'xlsx', sizeBytes: 56320, s3Key: 's3://genesis-uploads/dummy-wbd-offices-002', uploadedAt: '2026-02-27T11:00:00Z', status: 'uploaded' },
        ] },
        { id: 'wb-m2', role: 'genesis', type: 'question', text: 'Sweet Treat Tuesday confirmed monthly?', targetField: 'outputs.discovery.workflows[0].frequency', createdAt: '2026-02-27T11:04:00Z', attachments: [] },
        { id: 'wb-m3', role: 'rep', type: 'answer', text: 'Monthly, last Tuesday.', targetField: 'outputs.discovery.workflows[0].frequency', createdAt: '2026-02-27T11:07:00Z', attachments: [] },
        { id: 'wb-m4', role: 'genesis', type: 'message', text: 'Locked. Confidence medium overall.', targetField: null, createdAt: '2026-02-27T11:10:00Z', attachments: [] },
        { id: 'wb-m5', role: 'rep', type: 'message', text: 'Generate deck; we will validate hours in a follow-up.', targetField: null, createdAt: '2026-02-27T11:15:00Z', attachments: [] },
        { id: 'wb-m6', role: 'genesis', type: 'message', text: 'Deck generated with framework defaults.', targetField: null, createdAt: '2026-02-27T11:18:00Z', attachments: [] },
      ],
    },
    outcome: {
      result: 'pending',
      engagementSignal: null,
      notes: 'Thin discovery, deck used framework defaults. Follow-up call scheduled to validate hours.',
    },
    stages: ALL_STAGES_COMPLETE,
    outputs: {
      discovery: {
        teamsInScope: 1,
        workflows: [
          { name: 'Recurring activations (Sweet Treat Tuesday)', frequency: 'monthly', volume: '~20 offices', confidence: 'medium' },
          { name: 'Last-mile delivery coordination', frequency: 'per activation', volume: '~20 vendors', confidence: 'low' },
          { name: 'Local contact capacity management', frequency: 'ongoing', volume: '100 contacts', confidence: 'low' },
          { name: 'Vendor sourcing per market', frequency: 'as needed', volume: 'variable', confidence: 'low' },
          { name: 'Visibility & tracking across offices', frequency: 'continuous', volume: '100 offices', confidence: 'low' },
        ],
        vendors: ['Grokker', 'Uber Eats (informal)'],
        confidence: 'medium',
        notes: 'Call was 50% product demo, prospect dropped early, second half was internal team debrief. Many estimates inferred from context.',
      },
      pricing: {
        coordinationCost: 66000,
        phase3Anchor: 52800,
        enterpriseFloor: 60000,
        valueAnchor: 54000,
        maxOfThree: 60000,
        phase1: 2000,
        phase2: 3500,
        phase3: 4500,
        year1: 43500,
        alternative: 'distributed wellbeing coordination',
        orchestrationFee: '15%',
      },
      capabilities: [
        { name: 'Recurring Programs', status: 'live', usedFor: 'Sweet Treat Tuesday cadence' },
        { name: 'Last-Mile Delivery', status: 'planned', usedFor: 'Uber Direct routing' },
        { name: 'Eagle Eye', status: 'live', usedFor: 'Local vendor sourcing' },
        { name: 'Activity Dashboard', status: 'live', usedFor: 'Cross-office visibility' },
      ],
      buildCommitments: ['Uber Direct integration', 'Activation calendar template', 'Local contact capacity load-balancing'],
      visualAssets: {
        heroPrompt: 'WBD Wellbeing Sweet Treat Tuesday hero with confetti and pastel accents',
        palette: ['#1E3A8A', '#F472B6', '#FFFFFF'],
        generatedAssetUrls: [],
      },
      deck: { slides: 11, status: 'generated', filename: 'United_WBD_Wellbeing_Proposal.pdf' },
      loi: {
        status: 'draft',
        filename: 'United_WBD_Wellbeing_LOI_draft.pdf',
        url: null,
        signedAt: null,
      },
      agentLane: null,
    },
  },
];

export const IN_PROGRESS = {
  id: 'bms-2026-05',
  customer: 'Bristol-Myers Squibb',
  team: 'Employee Experience',
  teamLead: 'Marcus Chen',
  date: 'May 28, 2026',
  customerColor: '#0066A1',
  uploaded: '2 hours ago',
  overallConfidence: 'medium',
  lifecycle: 'in-progress',
  shape: { teams: null, offices: null, employees: null, industry: null },
  transcript: { filename: null, words: null, confidence: null, excerpt: null },
  customerLogo: { filename: null, width: null, height: null, mimeType: null, byteSize: null },
  chatThread: {
    messageCount: 8,
    durationMinutes: 12,
    messages: [
      { id: 'bms-m1', role: 'genesis', type: 'message', text: 'Transcript loaded. Discovery extraction running.', targetField: null, createdAt: '2026-05-30T08:00:00Z', attachments: [
        { id: 'bms-att-1', filename: 'bms_discovery_call_notes.txt', fileType: 'txt', sizeBytes: 18432, s3Key: 's3://genesis-uploads/dummy-bms-notes-003', uploadedAt: '2026-05-30T08:00:00Z', status: 'uploaded' },
      ] },
      { id: 'bms-m2', role: 'genesis', type: 'message', text: 'Captured 8 workflows. Confidence: medium.', targetField: null, createdAt: '2026-05-30T08:02:00Z', attachments: [] },
      { id: 'bms-m3', role: 'genesis', type: 'question', text: 'Confirm site count around 40?', targetField: 'shape.offices', createdAt: '2026-05-30T08:03:00Z', attachments: [] },
      { id: 'bms-m4', role: 'rep', type: 'answer', text: 'Yes, ~40 sites.', targetField: 'shape.offices', createdAt: '2026-05-30T08:05:00Z', attachments: [] },
      { id: 'bms-m5', role: 'genesis', type: 'message', text: 'Locking site count at 40. Working on pricing anchors now.', targetField: null, createdAt: '2026-05-30T08:10:00Z', attachments: [] },
    ],
  },
  outcome: {
    result: 'pending',
    engagementSignal: null,
    notes: 'In progress; pricing still computing.',
  },
  stages: {
    discovery: 'complete',
    pricing: 'in-progress',
    capabilities: 'pending',
    buildCommitments: 'pending',
    visualAssets: 'pending',
    deck: 'pending',
    loi: 'pending',
  },
  outputs: {
    discovery: {
      teamsInScope: 1,
      workflows: [
        { name: 'Sample workflow A', frequency: 'quarterly', volume: '~12 instances/yr', confidence: 'medium' },
        { name: 'Sample workflow B', frequency: 'ongoing', volume: '~40 sites', confidence: 'medium' },
      ],
      vendors: ['HRIS platform', 'wellness vendor'],
      confidence: 'medium',
      notes: 'Sample discovery data for in-progress run.',
    },
    pricing: null,
    capabilities: null,
    buildCommitments: null,
    visualAssets: null,
    deck: null,
    loi: null,
    agentLane: null,
  },
};

// Derived thread view. Flattens messages[].attachments into a single
// pool so callers can scan every file in a thread without walking
// messages. Reads through the source; does NOT duplicate state.
export function getThreadAttachments(thread) {
  if (!thread || !Array.isArray(thread.messages)) return [];
  return thread.messages.flatMap((m) => (Array.isArray(m.attachments) ? m.attachments : []));
}
